import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import ListRsvp from "./listRsvp";
import CreatForm from "./createForm";
import EditForm from "./editForm";
import ViewForm from "./viewForm";

export default function Index(props) {
  const location = useLocation();

  const [step, setStep] = useState("_a");
  const [selectedForm, setSelectedForm] = useState("");
  const [modalView, setModalView] = useState(false);
  return (
    <div>
      {step === "_a" && (
        <ListRsvp
          setStep={setStep}
          eventId={location.state.idEvent}
          setSelectedForm={setSelectedForm}
          setModalView={setModalView}
        />
      )}
      {step === "_b" && (
        <CreatForm
          setStep={setStep}
          eventId={location.state.idEvent}
          setSelectedForm={setSelectedForm}
        />
      )}
      {step === "_c" && (
        <EditForm
          setStep={setStep}
          eventId={location.state.idEvent}
          selectedForm={selectedForm}
        />
      )}
      {modalView && (
        <ViewForm
          setStep={setStep}
          selectedForm={selectedForm}
          modalIsOpen={modalView}
          toggle={() => setModalView(false)}
        />
      )}
    </div>
  );
}
